// extracted by mini-css-extract-plugin
export default {"following":"Following_following__IDP0Q","list":"Following_list__D52jf","seeMoreContainer":"Following_seeMoreContainer__6lOSN","seeMoreButton":"Following_seeMoreButton__-gyMA"};